<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-single-select-edit-control [(ngModel)]="model.data.overdue"
                                                        [allowClearSelectionOption]="false"
                                                        [formControlName]="'overdue'">
                            <wbo-select-options>
                                <wbo-select-option [value]="false" label="wbo.acc-receivable-report.options.accountIncluded.allDebtors"></wbo-select-option>
                                <wbo-select-option [value]="true" label="wbo.acc-receivable-report.options.accountIncluded.overdueDebtors"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-account-report-selection></wbo-account-report-selection>
            </fui-row>
            <fui-row *ngIf="Plugin.LOYALTY | booleanConfig">
                <wbo-membership-type-report-selection></wbo-membership-type-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
